import type { FaireProductEntity } from "../../entity_types/product";

export const p_vwp9gh2hzq: FaireProductEntity = {
  token: "p_vwp9gh2hzq",
  type: "product",
  name: "Osada Essential Blend 1kg",
  brandToken: "b_jkddc7grcu",
  brandName: "rocky's matcha",
  imageUrl: "https://cdn.faire.com/fastly/fd182d36b3b4ed9ca82ccb6846e6f0ed9140d051f6325a83f5a7849ca1760b8d.jpeg",
  galleryImageUrls: [],
  priceDollars: 175,
  description: "The Osada Essential Blend—an exclusive creation developed in partnership with Osada Tea and distributed by rocky’s matcha. This custom-crafted matcha blend boasts a vibrant green color, silky texture, and subtly roasted flavor, making it an ideal choice for those new to matcha. Smooth and versatile, the Osada Essential Blend is perfect for lattes and pairs beautifully with added sweeteners, offering a delightful balance of flavor for a range of preparations.\n\n*Note: our Osada Essential Blend is distributed by rocky’s matcha, and we kindly ask that our brand not be included in any marketing or menu references.",
  tags: [],
  msrpDollars: 350,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:20.322Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
